 <template>
  <div class="deliveryPage">
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.projectName"
        :required="editType"
        readonly
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        label="项目名称："
        class="ggInput"
        @click="showProjectPicker()"
        type="textarea"
        rows="1"
        autosize
      />
    </van-cell-group>
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.projectCode"
        type="textarea"
        label="合同编号："
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.summarize"
        rows="1"
        autosize
        :required="editType"
        label="项目概述："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.scale"
        rows="1"
        autosize
        :required="editType"
        label="项目规模："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.duration"
        rows="1"
        autosize
        :required="editType"
        label="工期要求："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <van-cell-group class="itemSite baseNone">
      <div class="gzlBox">
        <p>工作量分配：</p>
        <ul class="clearfix gzlTit">
          <li class="fl">姓名</li>
          <li class="fl">所属部门</li>
          <li class="fl">工作量占比（%）</li>
        </ul>
        <ul class="workloadBox" v-if="baseInput.workloadList[0]">
          <li
            v-for="(item, index) in baseInput.workloadList"
            :key="index"
            class="workloadItem"
          >
            <span>{{ item.userName }}</span>
            <span>{{ item.deptName }}</span>
            <span>{{ item.distributionProportion }}</span>
          </li>
        </ul>
      </div>
    </van-cell-group>

    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.archive"
        rows="1"
        autosize
        :required="editType"
        label="项目成果："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="reviewCommentName"
        label="有无评审意见："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkIsTypePicker(1)"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="isReplyName"
        label="有无批复："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkIsTypePicker(2)"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseSalary baseNone moreText">
      <van-field
        v-model="acceptanceReportName"
        label="有无验收报告："
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkIsTypePicker(3)"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.instructions"
        rows="1"
        autosize
        label="其他说明："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <van-cell-group class="itemSite beizhu baseNone">
      <van-field
        v-model="baseInput.remarks"
        rows="1"
        autosize
        label="备注："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && baseInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="baseInput"></audit-list>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && baseInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="baseInput"></flow-staff>
      <flow-list :workflowCode="baseInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="baseInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->

    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseInput.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">审批</van-button>
    </div>
    <!-- 弹出层 -->

    <!-- 项目列表 -->
    <!-- 是否需要审核 -->
    <van-popup v-model="isTypePicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="dictName"
        :columns="isTypeList"
        @cancel="isTypePicker = false"
        @confirm="onIsTypeConfirm"
      />
    </van-popup>
    <!-- 项目列表 -->
    <van-popup
      v-model="showProjrctListPicker"
      position="bottom"
      class="projectPicker"
    >
      <div class="projectListBox">
        <van-list
          v-model="itemLoading"
          :finished="itemFinished"
          finished-text="没有更多了"
          @load="getProjectList"
        >
          <van-radio-group v-model="radioItem">
            <van-cell-group class="baseNone baseSalary">
              <van-cell
                :title="`${projectItem.projectName}`"
                clickable
                v-for="projectItem in projectList"
                :key="projectItem.id"
                @click="selectitem(projectItem)"
              >
                <van-radio
                  slot="right-icon"
                  :name="`${projectItem.projectName}`"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-list>
      </div>
      <div class="selectBtn clearfix">
        <a href="javascript:void(0);" class="fl" @click="closeProject">取消</a>
        <a href="javascript:void(0);" class="fl" @click="saveProject()">确认</a>
      </div>
    </van-popup>
  </div>
</template> 

 <script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const retinueView = () => import("@/components/businessTripMould/retinueView");
const projectView = () => import("@/components/businessTripMould/projectView");
const fileView = () => import("@/components/common/fileView");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");

import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "deliveryPage",
  components: {
    retinueView,
    projectView,
    refreshPage,
    fileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseUrl: process.env.BASE_URL,
      refreshPagePicker: false,
      verifyPageType: false, //审批弹框,默认不显示
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      baseInput: {
        id: "",
        projectId: "", //项目编号
        projectName: "", //项目名称
        projectCode: "",
        summarize: "", //项目概述
        scale: "", //项目规模
        duration: "", //工期要求
        workloadList: [], //工作量分配
        instructions: "", //项目其他说明
        archive: "", //项目成果
        remarks: "", //备注
        reviewComment: false, //有无评审意见
        isReply: false, //有无批复
        acceptanceReport: false, //有无验收报告
        workflowCode: "",
      },
      reviewCommentName: "否",
      isReplyName: "否",
      acceptanceReportName: "否",
      checkedItemData: {},
      showProjrctListPicker: false, //项目类型弹框
      itempage: 0, //项目列表page
      pageSize: 99,
      itemTotal: 0, //项目总条数
      itemLoading: true, //是否处于加载状态
      itemFinished: false, //是否已加载完所有数据
      searchProjrctKey: "",
      radioItem: " ",
      projectList: [],
      sendType: "", //判断是否在抄送列表
      isTypePicker: false,
      checkTypeIndex: "",
      isTypeList: [
        { dictName: "是", dictCode: true },
        { dictName: "否", dictCode: false },
      ],
      clientType: getDeviceType(),
    };
  },
  mounted() {
    if (is_wei()) {
      document.title = "项目出库申请";
    }
  
    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    getDetails() {
      let _this = this;
      _this.$api.project.projectAchieve
        .getDetail(_this.commonId)
        .then((res) => {
          this.setShowLoad(false); //加载状态，默认为true加载
          if (res.code == "1" && res.data != null) {
            _this.baseInput = res.data;
            _this.reviewCommentName = _this.baseInput.reviewComment
              ? "是"
              : "否";
            _this.isReplyName = _this.baseInput.isReply ? "是" : "否";
            _this.acceptanceReportName = _this.baseInput.acceptanceReport
              ? "是"
              : "否";
            if (
              (_this.baseInput.verifyStatus == "hold" ||
                _this.baseInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              //  _this.getLeaveDay(res.data.leaveType,res.data.applicantId,res.data.workflowCode)
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },
    showProjectPicker(type) {
      if (this.editType) {
        this.radioItem = "";

        this.onSearch();
        this.showProjrctListPicker = true;
      }
    },
    /*关闭项目类型数据 */
    closeProject() {
      this.showProjrctListPicker = false;
    },
    /*保存项目类型数据*/
    saveProject() {
      let _this = this;
      if (_this.checkedItemData.projectName) {
        _this.baseInput.projectName = _this.checkedItemData.projectName;
        _this.baseInput.projectId = _this.checkedItemData.id;
        _this.baseInput.projectCode = _this.checkedItemData.projectCode;
        _this.getWorkloadUids();
        _this.showProjrctListPicker = false;
      } else {
        _this.$toast("请选择一个项目");
      }
    },
    //项目列表相关
    onSearch() {
      let _this = this;
      _this.itempage = 0;
      _this.itemLoading = true; //是否处于加载状态
      _this.itemFinished = false; //是否已加载完所有数据
      _this.projectList = [];
      _this.getProjectList();
    },
    getProjectList() {
      //获取项目列表
      let _this = this;
      if (
        _this.itempage != 0 &&
        _this.itempage * _this.pageSize >= parseInt(_this.itemTotal)
      ) {
        return;
      }
      _this.itempage += 1;
      _this.$api.project.projectAchieve
        .projectContract(_this.itempage, _this.pageSize)
        .then((res) => {
          if (res.code == "1") {
            _this.itemTotal = parseInt(res.data.total);
            _this.itemMainList = res.data.list;
            _this.viewItemLists();
            // 加载状态结束
            this.itemLoading = false;
            if (_this.itempage * _this.pageSize >= _this.itemTotal) {
              _this.itemFinished = true;
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.itemFinished = true;
          console.log(err);
        });
    },
    viewItemLists() {
      this.projectList = this.projectList.concat(this.itemMainList);
    },
    selectitem(item) {
      let _this = this;
      _this.radioItem = item.projectName;
      _this.checkedItemData.id = item.projectId;
      _this.checkedItemData.projectName = item.projectName;
      _this.checkedItemData.projectCode = item.projectCode;
    },
    getWorkloadUids() {
      let _this = this;
      _this.$api.project.projectAchieve
        .getWorkloadUids({ projectId: _this.baseInput.projectId })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseInput.workloadList = res.data;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },
    //获取是否审核
    checkIsTypePicker(type) {
      if (this.editType) {
        this.checkTypeIndex = type;
        this.isTypePicker = true;
      }
    },
    onIsTypeConfirm(data) {
      this.isTypePicker = false;
      if (this.checkTypeIndex == "1") {
        this.baseInput.reviewComment = data.dictCode;
        this.reviewCommentName = data.dictName;
      } else if (this.checkTypeIndex == "2") {
        this.baseInput.isReply = data.dictCode;
        this.isReplyName = data.dictName;
      } else if (this.checkTypeIndex == "3") {
        this.baseInput.acceptanceReport = data.dictCode;
        this.acceptanceReportName = data.dictName;
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      console.log(_this.baseInput);
      /*校验*/
      if (
        _this.baseInput.projectName == "" &&
        _this.baseInput.summarize == "" &&
        _this.baseInput.scale == "" &&
        _this.baseInput.duration == "" &&
        _this.baseInput.archive == ""
      ) {
        _this.$toast("带星号为必填，不能为空");
      } else {
        if (_this.baseInput.workloadList[0]) {
          _this.mode = msg;
          _this.saveAll();
        } else {
          _this.$toast("工作量不能为空");
        }
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.project.projectAchieve
        .addEdit(_this.mode, _this.baseInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.baseInput.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.project.projectAchieve
            .deleteRecall(_this.baseInput.verifyStatus, _this.baseInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.deliveryPage {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 70px;
  .baseNone {
    .van-cell__title {
      span {
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }

  .gzlBox {
    //工作量列表
    > p {
      width: 100%;
      padding: 15px 16px;
      font-size: 15px;
      line-height: 15px;
      color: #323233;
    }
    .gzlTit {
      li {
        font-size: 15px;
        height: 35px;
        line-height: 35px;
        color: #323233;
        text-align: center;
      }
      li:first-child {
        width: 25%;
      }
      li:nth-child(2) {
        width: 40%;
      }
      li:last-child {
        width: 35%;
      }
      border-top: 1px solid #ebedf0;
      border-bottom: 1px solid #ebedf0;
    }
    .workloadBox {
      .workloadItem {
        border-bottom: 1px solid #ebedf0;
        span {
          display: inline-block;
          text-align: center;
          color: #969799;
          font-size: 15px;
          height: 35px;
          line-height: 35px;
        }
        span:first-child {
          width: 25%;
        }
        span:nth-child(2) {
          width: 40%;
        }
        span:last-child {
          width: 35%;
        }
      }
      li.workloadItem:last-child {
        border-bottom: 0 none;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    border: 0 none;
    button {
      width: 100%;
      height: 45px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        display: inline-block;
        height: 45px;
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
  //审批操作样式
  //项目
  .projectPicker {
    width: 100%;
    height: 70%;
    padding-top: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    .projectListBox {
      width: 100%;
      height: calc(100% - 45px);
      overflow-y: scroll;
    }
    .selectBtn {
      z-index: 9999;
      position: fixed;
      width: 100%;
      font-size: 15px;
      text-align: center;
      color: #333;
      height: 45px;
      border-top: 1px solid #f6f6f6;
      bottom: 0;
      z-index: 999;
      background-color: #fff;

      a:first-child {
        color: rgb(235, 199, 155);
        border-right: 1px solid #f6f6f6;
        // background-color: rgb(235, 199, 155);
      }
      a {
        display: inline-block;
        width: 50%;
        height: 100%;
        line-height: 45px;
        color: #07c160;
        // background-color: #07c160;
        font-size: 15px;
        box-sizing: border-box;
      }
    }
  }
}
</style>


 